import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const home = () => import('../views/home.vue');

// const login = resolve => require(['../views/login.vue'], resolve);
// const retrievePassword = resolve => require(['../views/retrievePassword.vue'], resolve);
// const dashboard = resolve => require(['../views/dashboard.vue'], resolve);
// const room = resolve => require(['../views/room.vue'], resolve);
// const lights = resolve => require(['../views/lights.vue'], resolve);
// const circadianLights = resolve => require(['../views/circadianLights.vue'], resolve);
// const sensor = resolve => require(['../views/sensor.vue'], resolve);
// const service = resolve => require(['../views/service.vue'], resolve);
// const airPurifiers = resolve => require(['../views/airPurifiers.vue'], resolve);
// const activityHistory = resolve => require(['../views/activityHistory.vue'], resolve);
// const userManagement = resolve => require(['../views/userManagement.vue'], resolve);
// const siteManagement = resolve => require(['../views/siteManagement.vue'], resolve);
// const room_light = resolve => require(['../views/room-light.vue'], resolve);
// const gateway = resolve => require(['../views/gateway.vue'], resolve);

const login = () => import('../views/login.vue');
// const retrievePassword = () => import('../views/retrievePassword.vue');
// // const dashboard = () => import('../views/dashboard_.vue');
// const dashboard = () => import('../views/dashboard.vue');
// const room = () => import('../views/room.vue');

// const classroomLights = () => import('../views/class/classroomLights.vue');
// const blackboardLights = () => import('../views/class/blackboardLights.vue');
// const switchPanel = () => import('../views/class/switchPanel.vue');
// const curtain = () => import('../views/class/curtain.vue');
// const grouping = () => import('../views/class/grouping.vue');


// const lights = () => import('../views/lights.vue');
// const circadianLights = () => import('../views/circadianLights.vue');
// const circadianLightsPlan = () => import('../views/circadianLightsPlan.vue');
// const sensor = () => import('../views/sensor.vue');
// const uvLight = () => import('../views/uvLight.vue');

// const service = () => import('../views/service/service.vue');
// const maintenanceStaff = () => import('../views/service/maintenanceStaff.vue');
// const pushSetting = () => import('../views/service/pushSetting.vue');
// const alarmProfile = () => import('../views/service/alarmProfile.vue');

// const airPurifiers = () => import('../views/airPurifiers.vue');
// const activityHistory = () => import('../views/activityHistory.vue');
// const userManagement = () => import('../views/userManagement.vue');
// const siteManagement = () => import('../views/siteManagement.vue');
// const room_light = () => import('../views/room-light.vue');
// const gateway = () => import('../views/gateway.vue');

const routes = [
  {
    path: '/',
    component: login,
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/login',
    name: 'login',
    component: login
  }
  // {
  //   path: '/retrievePassword',
  //   name: 'retrievePassword',
  //   component: retrievePassword
  // },
  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   component: dashboard
  // },
  // {
  //   path: '/room',
  //   name: 'room',
  //   component: room
  // },

  // {
  //   path: '/classroomLights',
  //   name: 'classroomLights',
  //   component: classroomLights
  // },
  // {
  //   path: '/grouping',
  //   name: 'grouping',
  //   component: grouping
  // },

  // {
  //   path: '/blackboardLights',
  //   name: 'blackboardLights',
  //   component: blackboardLights
  // },
  // {
  //   path: '/switchPanel',
  //   name: 'switchPanel',
  //   component: switchPanel
  // },
  // {
  //   path: '/curtain',
  //   name: 'curtain',
  //   component: curtain
  // },

  // {
  //   path: '/lights',
  //   name: 'lights',
  //   component: lights
  // },
  // {
  //   path: '/circadianLights',
  //   name: 'circadianLights',
  //   component: circadianLights
  // },
  // {
  //   path: '/circadianLightsPlan',
  //   name: 'circadianLightsPlan',
  //   component: circadianLightsPlan
  // },
  // {
  //   path: '/sensor',
  //   name: 'sensor',
  //   component: sensor
  // },
  // {
  //   path: '/uvLight',
  //   name: 'uvLight',
  //   component: uvLight
  // },
  // {
  //   path: '/service',
  //   name: 'service',
  //   component: service
  // },
  // {
  //   path: '/maintenanceStaff',
  //   name: 'maintenanceStaff',
  //   component: maintenanceStaff
  // },
  // {
  //   path: '/pushSetting',
  //   name: 'pushSetting',
  //   component: pushSetting
  // },
  // {
  //   path: '/alarmProfile',
  //   name: 'alarmProfile',
  //   component: alarmProfile
  // },
  // {
  //   path: '/airPurifiers',
  //   name: 'airPurifiers',
  //   component: airPurifiers
  // },
  // {
  //   path: '/gateway',
  //   name: 'gateway',
  //   component: gateway
  // },
  // {
  //   path: '/activityHistory',
  //   name: 'activityHistory',
  //   component: activityHistory
  // },
  // {
  //   path: '/userManagement',
  //   name: 'userManagement',
  //   component: userManagement
  // },
  // {
  //   path: '/siteManagement',
  //   name: 'siteManagement',
  //   component: siteManagement
  // },
  // {
  //   path: '/room-light',
  //   name: 'room-light',
  //   component: room_light
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
